import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button } from '@coursera/cds-core';

import type { FilterCtrls, Filters } from 'bundles/enterprise-admin-drawers/components/types';

import _t from 'i18n!nls/admin-dashboard';

import FilterPill from '../elements/FilterPill';

export type Props = {
  onChange: (filters: Filters) => void;
  filters: Filters;
  filterCtrls: FilterCtrls;
  onOpen: () => void;
  maxVisibleFilters?: number;
};

type FilterOptionTypeCount = {
  type: keyof Filters;
  label: string;
  count: number;
};

export const DEFAULT_MAX_VISIBLE_FILTERS = 3;

export class AggregatedFilterBox extends React.Component<Props> {
  handleDismiss = (dismissedKey: keyof Filters) => () => {
    const { filters, onChange } = this.props;
    const newFilters = { ...filters, [dismissedKey]: [] };

    onChange(newFilters);
  };

  aggregateFilters = (): FilterOptionTypeCount[] => {
    const { filters, filterCtrls } = this.props;

    return Object.keys(filterCtrls)
      .map(
        (filterKey): FilterOptionTypeCount => ({
          type: filterKey,
          label: filterCtrls[filterKey].label,
          count: filters[filterKey].length,
        })
      )
      .filter((filterOptionCount) => filterOptionCount.count !== 0);
  };

  render() {
    const { onOpen, maxVisibleFilters } = this.props;
    const filterCounts = this.aggregateFilters();
    const maxFilters = maxVisibleFilters || DEFAULT_MAX_VISIBLE_FILTERS;

    return (
      <div className="rc-AggregatedFilterBox horizontal-box">
        {filterCounts.slice(0, maxFilters).map((f) => (
          <FilterPill
            type={f.type}
            rootClassName="m-l-1s"
            key={f.type}
            label={`${f.label} · ${f.count}`}
            onDismiss={this.handleDismiss(f.type)}
          />
        ))}
        {filterCounts.length > maxFilters && (
          <Button className="c-more m-l-1s" variant="ghost" onClick={onOpen}>
            <FormattedMessage message={_t(`+{count} more`)} count={String(filterCounts.length - maxFilters)} />
          </Button>
        )}
      </div>
    );
  }
}

export default AggregatedFilterBox;
